<script lang="ts">
    import AppLayout from "@/layouts/AppLayout.svelte";
    import {Plus} from "lucide-svelte";
    import type {Customer, Site} from "@/types/types";
    import type Blocks from "@/schemas/public/Blocks";
    import type {Field} from "@/types/types";
    import SiteTable from "@/components/sites/SiteTable.svelte";
    import CreateRecordModal from "@/components/CreateRecordModal.svelte";
    import CreateSiteModal from "@/components/sites/CreateSiteModal.svelte";
    import DocumentsTable from "@/components/documents/DocumentTable.svelte";
    import CreateDocumentModal from "@/components/documents/CreateDocumentModal.svelte";


    type Props = {
        blocks: (Blocks & { fields: Field[] })[];
    };

    let {blocks}: Props = $props();

    let breadcrumbs = $state([
        {title: 'Documents', href: route('documents.index')},
    ]);


    let showCreateDocumentModal = $state(false);
    function openCreateDocumentModal() {
        showCreateDocumentModal = true;
    }

    let actionbuttons = $state([
        {
            title: 'Add New Document',
            href: undefined,
            icon: Plus,
            onClick: openCreateDocumentModal,
        },
    ]);

</script>

<svelte:head>
    <title>Documents</title>
</svelte:head>
<!--</HeaderActionButtons>-->
<AppLayout {breadcrumbs} {actionbuttons}>
    <div>
        <DocumentsTable view="index"/>
    </div>
    <CreateDocumentModal
        blocks={blocks}
        show={showCreateDocumentModal}
    />

</AppLayout>
